import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row justify-content-center mt-30" }
const _hoisted_2 = { class: "col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_4 = { class: "card-body letter-spacing" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Sign-In To Your Account! ", -1)
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fs-md-15 fs-lg-16",
  role: "alert"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1)
const _hoisted_8 = { class: "d-flex justify-content-center align-items-center mt-4 sso-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "d-block or text-muted text-center mt-30 mb-20 mt-md-30 mb-md-30 fs-md-15 fs-lg-16 position-relative z-1 lh-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block bg-white" }, "Or")
], -1)
const _hoisted_10 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center my-4"
}
const _hoisted_11 = {
  key: 2,
  class: "traditional-login-container"
}
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Username ", -1)
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Password ", -1)
const _hoisted_16 = { class: "d-flex align-items-center justify-content-between mb-15 mb-md-20" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://dbt9q0ovf1s.typeform.com/to/wUvD8MOm",
  target: "_blank",
  class: "forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
}, " Request Access! ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://dbt9q0ovf1s.typeform.com/to/mg3AYJ6Y",
  target: "_blank",
  class: "forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
}, " Forgot Password? ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://dbt9q0ovf1s.typeform.com/to/wUvD8MOm",
  target: "_blank",
  class: "forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
}, " Request Access! ", -1)
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16" }, " Don’t have an account? ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LegalLinks = _resolveComponent("LegalLinks")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              class: "mt-50"
            }, [
              ($setup.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString($setup.errorMessage) + " ", 1),
                    _hoisted_7
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_GoogleLogin, {
                  callback: $setup.performLoginWithGoogle,
                  prompt: "",
                  "auto-login": "",
                  "button-config": { size: 'large', 'theme': 'filled_blue', 'width': '250' }
                }, null, 8, ["callback"])
              ]),
              _hoisted_9,
              (!$setup.showTraditionalLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleTraditionalLogin && $setup.toggleTraditionalLogin(...args))),
                      class: "btn transition border-0 fw-medium text-white rounded-1 fs-md-13 fs-lg-14 bg-secondary d-block"
                    }, _toDisplayString($setup.showTraditionalLogin ? 'Hide Traditional Login' : 'Login with Username'), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.showTraditionalLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control shadow-none rounded-0 text-black",
                        placeholder: "Username",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.username) = $event)),
                        require: ""
                      }, null, 512), [
                        [_vModelText, $setup.username]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        class: "form-control shadow-none rounded-0 text-black",
                        placeholder: "**************",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.password) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, $setup.password]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      ($setup.canAccessFeature('forgotPassword'))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_router_link, {
                              to: "/forgot-password",
                              class: "forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Forgot Password? ")
                              ]),
                              _: 1
                            }),
                            _hoisted_17
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_18,
                            _hoisted_19
                          ], 64))
                    ]),
                    _createElementVNode("button", {
                      class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100",
                      disabled: $setup.isLoading,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.performLogin && $setup.performLogin(...args)))
                    }, " Sign In Now ", 8, _hoisted_20),
                    ($setup.canAccessFeature('register'))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_21,
                          _createVNode(_component_router_link, {
                            to: "/register",
                            class: "default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Create Account ")
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ])
      ])
    ]),
    _createVNode(_component_LegalLinks)
  ], 64))
}